export enum TIME_RANGE_VALUES {
    PT24H = 'PT24H',
    PT168H = 'PT168H',
    PT720H = 'PT720H',
    PT2160H = 'PT2160H',
}
